<script setup>
import {Notification, NotificationGroup} from "notiwind";
</script>

<template>
    <NotificationGroup>
        <div class="fixed inset-0 flex items-start justify-end pointer-events-none max-w-8xl px-6 mr-6 mt-6 lg:mx-auto z-[100]">
            <Notification>
                <template v-slot="{ notifications, close }">
                    <transition-group
                        tag="div"
                        enter-active-class="transition ease-out"
                        enter-from-class="transform opacity-0 translate-x-6"
                        leave-active-class="transition ease-out"
                        leave-to-class="transform opacity-0 translate-x-6"
                    >
                        <div v-for="notification in notifications" :key="notification.id" v-on:click="close" class="bg-[rgba(20,22,57,1)] rounded-2xl px-8 py-6 pr-20 flex items-center space-x-4 mb-3 relative pointer-events-auto cursor-pointer text-[rgba(255,255,255,1)] text-sm">
                            {{ notification.body }}
                        </div>
                    </transition-group>
                </template>
            </Notification>
        </div>
    </NotificationGroup>
</template>
